import type { api } from '@stageplottter/core';
import { getApi } from './endpoints';

export type RuntimeConfig = api.RuntimeConfig;

/** Defaults used when the server is unreachable (local-first: the editor still works offline). */
export function fallbackConfig(loc: { protocol: string; host: string } | undefined): RuntimeConfig {
  const wsProto = loc?.protocol === 'https:' ? 'wss:' : 'ws:';
  return {
    version: 'offline',
    authEnabled: true,
    collabUrl: `${wsProto}//${loc?.host ?? 'localhost'}/collab`,
    defaultLocale: 'en',
    errorTrackingDsn: null,
    limits: { maxUploadBytes: 10 * 1024 * 1024 },
  };
}

/** Relative collab URLs ("/collab") are resolved against the current origin. */
export function resolveCollabUrl(
  url: string,
  loc: { protocol: string; host: string } | undefined,
): string {
  if (/^wss?:\/\//.test(url)) return url;
  const wsProto = loc?.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${wsProto}//${loc?.host ?? 'localhost'}${url.startsWith('/') ? '' : '/'}${url}`;
}

let pending: Promise<RuntimeConfig> | null = null;

export function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const loc = typeof window === 'undefined' ? undefined : window.location;
  pending ??= getApi()
    .config()
    .then((c) => ({ ...c, collabUrl: resolveCollabUrl(c.collabUrl, loc) }))
    .catch(() => fallbackConfig(loc));
  return pending;
}

export function resetRuntimeConfig(): void {
  pending = null;
}
